import api from 'src/config/api';
import {
	IUpdateUserRequest,
	IUserOption,
} from 'src/features/user/domain/types';
import {
	IUser,
	ICreateUserRequest,
	IGetUsersRequestParams,
} from 'src/features/user/domain/types';

export const userApi = {
	getUsers: async (
		requestParams: IGetUsersRequestParams,
	): Promise<IPaginatedResponse<IUser>> => {
		const { page = 1, search, sort, order, type, status } = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
			...(search && { search }),
			...(sort && order && { sort, order }),
			...(type && { type }),
			...(status && { status }),
		});

		const response = await api.get(`/api/v1/users?${params}`);
		return response.data;
	},

	createUser: async (userData: ICreateUserRequest): Promise<IUser> => {
		const response = await api.post('/api/v1/user', userData);
		return response.data;
	},

	updateUser: async (
		userData: IUpdateUserRequest,
		userId: number,
	): Promise<IUser> => {
		const response = await api.patch(`/api/v1/user/${userId}`, userData);
		return response.data;
	},

	getGeneralUsers: async (): Promise<IUserOption[]> => {
		const response = await api.get('/api/v1/users/short-info');
		return response.data;
	},
};
